import { render, staticRenderFns } from "./FeriaRequest.vue?vue&type=template&id=cd367dc8&scoped=true"
import script from "./FeriaRequest.vue?vue&type=script&lang=ts"
export * from "./FeriaRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd367dc8",
  null
  
)

export default component.exports